import * as i0 from '@angular/core';
import { ChangeDetectorRef, inject, Component, ChangeDetectionStrategy, ViewChild, Input } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { iconDownload, IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { ProgressIndicatorComponent } from '@knorr-bremse-portals/ngx-components/components/progress-indicator';
import { ButtonComponent } from '@knorr-bremse-portals/ngx-components/components/button';

function isGenerationCompleteEvent(event) {
    return event.name !== undefined;
}
class GeneratedDownloadButtonComponent {
    constructor() {
        this.icon = iconDownload;
        this.progress = 0;
        this.preparing = false;
        this.cdr = inject(ChangeDetectorRef);
    }
    download() {
        this.preparing = true;
        this.generateFile().subscribe({
            next: (event) => {
                if (isGenerationCompleteEvent(event)) {
                    const blob = new Blob([event.content], { type: event.mimeType });
                    const blobUrl = window.URL.createObjectURL(blob);
                    const downloadAnchorElement = this.downloadAnchorElement.nativeElement;
                    downloadAnchorElement.setAttribute('download', event.name);
                    downloadAnchorElement.setAttribute('href', blobUrl);
                    downloadAnchorElement.click();
                    queueMicrotask(() => {
                        window.URL.revokeObjectURL(blobUrl);
                    });
                    this.preparing = false;
                    this.cdr.markForCheck();
                }
                else {
                    this.progress = event.completed;
                    this.targetProgress = event.total;
                    this.cdr.markForCheck();
                }
            },
            error: () => {
                this.preparing = false;
                this.progress = 0;
                this.targetProgress = undefined;
                this.cdr.markForCheck();
                alert('Failed to prepare download'); // TODO: replace this with a better ui
            },
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: GeneratedDownloadButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.0.7", type: GeneratedDownloadButtonComponent, isStandalone: true, selector: "kb-generated-download-button", inputs: { generateFile: "generateFile", icon: "icon" }, viewQueries: [{ propertyName: "downloadAnchorElement", first: true, predicate: ["downloadAnchorElement"], descendants: true, static: true }], ngImport: i0, template: "<div kb-layout=\"flex\">\n  <button kb-button (click)=\"download();\" type=\"button\" [disabled]=\"preparing\">\n    <ng-content></ng-content>\n\n    <kb-icon [icon]=\"icon\"></kb-icon>\n  </button>\n  <kb-progress-indicator [visible]=\"preparing\"></kb-progress-indicator>\n  <p kb-paragraph *ngIf=\"preparing && targetProgress !== undefined\">{{progress}} / {{targetProgress}}</p>\n</div>\n<a #downloadAnchorElement></a>\n", styles: [":host a{display:none}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IconComponent, selector: "kb-icon, button[kb-icon], a[kb-icon]", inputs: ["icon"] }, { kind: "component", type: ProgressIndicatorComponent, selector: "kb-progress-indicator", inputs: ["design", "type", "background", "visible"] }, { kind: "component", type: ButtonComponent, selector: "button[kb-button], a[kb-button]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.0.7", ngImport: i0, type: GeneratedDownloadButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'kb-generated-download-button', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [CommonModule, IconComponent, ProgressIndicatorComponent, ButtonComponent], template: "<div kb-layout=\"flex\">\n  <button kb-button (click)=\"download();\" type=\"button\" [disabled]=\"preparing\">\n    <ng-content></ng-content>\n\n    <kb-icon [icon]=\"icon\"></kb-icon>\n  </button>\n  <kb-progress-indicator [visible]=\"preparing\"></kb-progress-indicator>\n  <p kb-paragraph *ngIf=\"preparing && targetProgress !== undefined\">{{progress}} / {{targetProgress}}</p>\n</div>\n<a #downloadAnchorElement></a>\n", styles: [":host a{display:none}\n"] }]
        }], propDecorators: { downloadAnchorElement: [{
                type: ViewChild,
                args: ['downloadAnchorElement', { static: true }]
            }], generateFile: [{
                type: Input,
                args: [{ required: true }]
            }], icon: [{
                type: Input
            }] } });

/**
 * Generated bundle index. Do not edit.
 */

export { GeneratedDownloadButtonComponent };
